import React from "react";

interface AccordionContextData {
  openIds: string[];
  onToggle: (id: string, open: boolean) => void;
}

export const AccordionContext = React.createContext<AccordionContextData>({
  openIds: [],
  onToggle: () => {
    throw new Error("Not implemented!");
  },
});
